<template>
    <div class="firstpage">
      <img class="kv-bg" v-if="isPortrait" :src="preText + '/assets/~/media/images/vehicle/newseltos/tech/mob/kejifengmian-mob.jpg'" alt="" />
      <img class="kv-bg" v-else :src="preText + '/assets/~/media/images/vehicle/newseltos/tech/pc/fengmian-pc.jpg'" alt="" />
  
      <!-- <img
        class="play-btn"
        v-if="isPortrait"
        :src="preText + '/assets/~/media/images/activity/sp2co/mob/play.png'"
        alt=""
        @click="openVideo"
        code-stm="event, PAGEURL, 封面视频点击"
      />
      <img
        class="play-btn"
        v-else
        :src="preText + '/assets/~/media/images/activity/sp2co/pc/play.png'"
        alt=""
        @click="openVideo"
        code-stm="event, PAGEURL, 封面视频点击"
      /> -->
  
      <img
        class="swiper-btn"
        :src="swiperButtonSrc"
        alt=""
        @mouseenter="setSwiperButtonHover(true)"
        @mouseleave="setSwiperButtonHover(false)"
        @click="openSwiper"
        code-stm="event, PAGEURL, 轮播图弹窗点击"
      />
  
      <PopVideo :visible.sync="isShowVideo" :video-url="fullVideoUrl" :codeGa="'封面视频'" :codeStm="'封面视频'"  />
      <PopSwiper :visible.sync="isShowSwiper" />
    </div>
  </template>
  
  <script>
  import { isPortraitFun, getUrlKey } from "@/utils/utils.js";
  import PopVideo from "./pop-video.vue";
  import PopSwiper from "./pop-swiper.vue";
  
  const VIDEO_URL = "https://img.kia.cn/media/videos/202607/newsaitusimeijie/sp3c2026071702.mp4";
  
  export default {
    name: "SeltosVideoPopupSwiper",
    components: { PopVideo, PopSwiper },
    data() {
      return {
        isPortrait: isPortraitFun(),
        minip: false,
        preText: "https://www.kia.cn",
        isShowVideo: false,
        fullVideoUrl: "",
        isShowSwiper: false,
        isSwiperButtonHovered: false,
      };
    },
    computed: {
      swiperButtonSrc() {
        const fileName = !this.isPortrait && this.isSwiperButtonHovered
          ? "btn-hover.png"
          : "btn.png";
        return `${this.preText}/assets/~/media/images/vehicle/newseltos/swipervideos/${fileName}`;
      },
    },
    watch: {
      isShowVideo() {
        this.syncParentPopupState();
      },
      isShowSwiper() {
        this.syncParentPopupState();
      },
    },
    mounted() {
      if (!window.location.href.includes("kia-web-htmleditor-components-prod")) {
        this.preText = "https://uat.kia.cn";
      } else {
        this.preText = "https://www.kia.cn";
      }
      if (getUrlKey("minip")) {
        this.minip = true;
      }
    },
    methods: {
      setSwiperButtonHover(isHovered) {
        if (!this.isPortrait) {
          this.isSwiperButtonHovered = isHovered;
        }
      },
      notifyParent(type) {
        if (window.parent !== window) {
          window.parent.postMessage({ type }, "*");
        }
      },
      syncParentPopupState() {
        const type = this.isShowVideo || this.isShowSwiper
          ? "seltosVideoPopupOpen"
          : "seltosVideoPopupClose";
        this.notifyParent(type);
      },
      openVideo() {
        this.fullVideoUrl = VIDEO_URL;
        this.isShowVideo = true;
      },
      openSwiper() {
        this.isShowSwiper = true;
      },
    },
    beforeDestroy() {
      this.notifyParent("seltosVideoPopupClose");
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .firstpage {
    position: relative;
    width: 100%;
    user-select: none;
    z-index: 0;
    height: calc(1080 / 1920  * 100vw) !important;
    .kv-bg {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    @media (max-width: 767px) {
      height: calc(1370 / 750  * 100vw) !important;
    }
    .play-btn {
      width: calc(90 / 2200 * 100vw);
      height: calc(90 / 2200 * 100vw);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: calc(633 / 2200 * 100vw);
      cursor: pointer;
      @media (max-width: 767px) {
        width: calc(113 / 1125 * 100vw);
        height: calc(113 / 1125 * 100vw);
        top: calc(670 / 1125 * 100vw);
      }
    }
    .swiper-btn {
      width: calc(219 / 1920 * 100vw);
      height: calc(66 / 1920 * 100vw);
      position: absolute;
      left: calc(558 / 1920 * 100vw);
      top: calc(112 / 1920 * 100vw);
      transform: translateX(-50%);
      
      cursor: pointer;
      @media (max-width: 767px) {
        width: calc(325 / 1125 * 100vw);
        height: calc(112 / 1125 * 100vw);
        left: calc(451 / 750 * 100vw);
        top: calc(157 / 750 * 100vw);
      }
    }
  }
  </style>
  
